/** Shopify CDN: Minification failed

Line 79:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 80:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 106:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 120:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 127:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 132:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 136:9 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 68:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 69:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 95:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 109:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 116:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 121:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 125:9 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 57:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 58:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 84:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 98:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 105:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 110:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 114:9 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 46:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 47:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 73:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 87:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 94:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 99:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 103:9 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 35:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 36:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 62:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 76:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 83:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 88:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 92:9 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 24:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 25:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 51:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 65:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 72:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 77:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 81:9 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 13:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 14:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 40:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 54:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 61:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 66:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 70:9 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
if (!customElements.get('share-button')) {
  customElements.define('share-button', class ShareButton extends HTMLElement {
    constructor() {
      super();

      this.mainDetailsToggle = this.querySelector('details');

      this.elements = {
        shareButton: this.querySelector('button'),
        shareSummary: this.querySelector('summary'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input')
      }
      this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

      if (navigator.share) {
        this.mainDetailsToggle.setAttribute('hidden', '');
        this.elements.shareButton.classList.remove('hidden');
        this.elements.shareButton.addEventListener('click', () => { navigator.share({ url: this.urlToShare, title: document.title }) });
      }
      else {
        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__input').addEventListener('click', this.copyToClipboard.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__copy').addEventListener('click', this.copyToClipboard.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
      }
    }

    toggleDetails() {
      if (!this.mainDetailsToggle.open) {
        this.elements.successMessage.classList.add('hidden');
        this.elements.successMessage.textContent = '';
        this.elements.shareSummary.focus();
      }
      else {
        setTimeout(() => {
          this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
          document.body.addEventListener('click', this.onBodyClickEvent);
        });
      }
    }

    copyToClipboard() {
      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        this.elements.successMessage.classList.remove('hidden');
        this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
      });
    }

    updateUrl(url) {
      this.urlToShare = url;
      this.elements.urlInput.value = url;
    }

    onBodyClick(event) {
      if (!this.contains(event.target)) this.close();
    }

    close() {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);

      document.body.removeEventListener('click', this.onBodyClickEvent);
    }
  });
}
